export default __webpack_public_path__ + "static/media/GoodSmiley.146025bd.svg";